import {setLocale} from "yup";
import {i18_TRANSLATION} from "./i18nReferences";
import * as yup from 'yup';
import { isValidE164 } from "@kiss-solutions/countries";

yup.addMethod(yup.string, 'phoneE164', function () {
    return this.test({
      name: 'phoneE164',
      message: { key: 'YUP.ERROR.INVALID_E164' },
      test: (value) => {
        // Allow empty values; leave required handling to .required()
        if (value == null || value === '') return true;
        return isValidE164(value);
      }
    });
  });

setLocale({
    mixed: {
        required: () => ({key: 'YUP.ERROR.NEED'})
    },
    number: {
        min: ({min}) => ( { key: 'YUP.ERROR.FIELD_TOO_SHORT', values: { min } }),
        max: ({max}) => ( { key: 'YUP.ERROR.FIELD_TOO_BIG', values: { max } }),
    },
    string: {
        min: ({min}) => ( { key: 'YUP.ERROR.STRING_FIELD_TOO_SHORT', values: { min } }),
        max: ({max}) => ( { key: 'YUP.ERROR.STRING_FIELD_TOO_LONG', values: { max } }),
    },
    date: {
        required: () => ({key: 'YUP.ERROR.NEED'}),
        min: () => ( { key: 'YUP.ERROR.TOO_EARLY' }),
    }
})

// Helper function to get nested error by path (e.g., 'termin.Betreff')
const getNestedError = (errors, fieldPath) => {
    if (!fieldPath || !errors) return null;
    
    const pathParts = fieldPath.split('.');
    let current = errors;
    
    for (const part of pathParts) {
        if (current && typeof current === 'object' && part in current) {
            current = current[part];
        } else {
            return null;
        }
    }
    
    return current;
}

export const getHelperText = (t, errors, fieldName, ns) => {
    // Support both flat and nested field paths
    const error = getNestedError(errors, fieldName);
    
    if (!error || !error.message) {
        return null
    }
    // Server errors set via setError arrive already localized as plain strings; only yup messages
    // are the { key, values } shape this helper translates.
    if (typeof error.message === 'string') {
        return error.message
    }
    const values = error.message.values || {}
    return t(error.message.key, {...values, ns: error.message.ns || ns || i18_TRANSLATION})
}

export const isError = (errors, fieldName) => {
    const error = getNestedError(errors, fieldName);
    return error && error.message && error.message.key && error.message.key.indexOf('ERROR') > 0
}

export const isWarningMessage = (message) => message?.key?.includes("WARNING");

export const analyzeValidationErrors = (errors) => {
    const realErrors = {};
    const warnings = {};

    if (!errors || typeof errors !== "object") {
        return { realErrors, warnings };
    }

    Object.keys(errors).forEach((segment) => {
        const segmentObj = errors[segment];
        if (!segmentObj || typeof segmentObj !== "object") {
            return;
        }

        Object.keys(segmentObj).forEach((key) => {
            const error = segmentObj[key];
            const flatKey = `${segment}.${key}`;
            if (isWarningMessage(error?.message)) {
                warnings[flatKey] = error;
            } else {
                realErrors[flatKey] = error;
            }
        });
    });

    return { realErrors, warnings };
};

export const hasBlockingFormErrors = (errors) => Object.keys(analyzeValidationErrors(errors).realErrors).length > 0;

export const hasBlockingValidationError = (validationError) => {
    const validationErrors = validationError?.inner?.length ? validationError.inner : [validationError];
    return validationErrors.some((error) => !isWarningMessage(error?.message));
};
